// <!--Google Tag Manager-->
(function (win, doc, scriptTagName, dataLayerName) {
  const devId = 'GTM-WZMCZDPX';
  const productionId = 'GTM-5DGKZD77';
  const ids = {
    'reefnbid.com': productionId,
    'staging.reefnbid.com': 'GTM-WN3BDZ8K',
  };
  const id = ids[location.host] ?? devId;
  // const id = productionId;

  win[dataLayerName] = win[dataLayerName] || [];
  win[dataLayerName].push({
    'gtm.start':
      new Date().getTime(), event: 'gtm.js'
  });
  var firstScript = doc.getElementsByTagName(scriptTagName)[0];
  var scriptEle = doc.createElement(scriptTagName);
  var dataLayerParam = dataLayerName != 'dataLayer' ? '&l=' + dataLayerName : '';
  scriptEle.async = true;
  scriptEle.src = 'https://www.googletagmanager.com/gtm.js?id=' + id + dataLayerParam;
  firstScript.parentNode.insertBefore(scriptEle, firstScript);
})(window, document, 'script', 'dataLayer');
// <!--End Google Tag Manager-->

(function () {
  // heap
  const heapProd = '3024953433'
  const heapDev = '4012976282'
  // heap.io
  window.heap = window.heap || [], heap.load = function (e, t) { window.heap.appid = e, window.heap.config = t = t || {}; var r = document.createElement("script"); r.type = "text/javascript", r.async = !0, r.src = "https://cdn.heapanalytics.com/js/heap-" + e + ".js"; var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(r, a); for (var n = function (e) { return function () { heap.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "resetIdentity", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"], o = 0; o < p.length; o++)heap[p[o]] = n(p[o]) };
  heap.load((location.hostname === 'reefnbid.com') ? heapProd : heapDev);

  return; // google analytics tag in gtm

  const ids = {
    'reefnbid.com': 'G-EE95T7C4TW',
    'reefbay-dev4.myshopify.com': 'G-ZWND9EY5TQ',
    'staging.reefnbid.com': 'G-PP5HRVKQQ6',
  }
  const id = ids[location.host]
  if (!id) return

  // Google tag (gtag.js)
  window.dataLayer = window.dataLayer || [];
  function gtag () { window.dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', id);

  const ele = document.createElement('script')
  ele.async = true
  ele.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
  document.head.appendChild(ele)
})()
